import { lazy } from "react";
import {
  BackgroundContainer
} from "./styles";


const Container = lazy(() => import("../../common/Container"));
const ScrollToTop = lazy(() => import("../../common/ScrollToTop"));
const FarmBlock = lazy(() => import ("../../components/Farm/FarmBlock"));


const Farm = () => {
  return (
    <>
    <BackgroundContainer>
        <div style={{
              
        }}>
          <Container>
            <FarmBlock/>
          </Container>
        </div>
        <ScrollToTop />
    </BackgroundContainer>
    </>
  );
};
export default Farm;
